import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
// import socket from "../componentes/Socket";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
// Helper
import GetFetchPush from "../helper/GetFetchPush";
import GetFetchNotificacion from "../helper/GetFetchNotificaciones";
//Hook
import useNotificaciones from "../hooks/useNotificaciones";

import loadMenu from "../js/main";
import Footer from "../componentes/Footer";

import "../css/styleAdmin.css";
// import { data } from 'jquery';

const Push = () => {
  const history = useHistory();

  // const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");
  const { noti } = useNotificaciones;

  if (!datos) {
    history.push("/");
  }

  let cred = JSON.parse(datos);
  if (dataSuper.indexOf(cred.carnet.trim()) === -1) {
    if (dataDireccionEstudiantil.indexOf(cred.carnet.trim()) === -1) {
      history.push("/");
    }
  }

  datos = JSON.parse(datos);

  const [textMensage, setTextMensage] = useState(null);
  const [file, setFile] = useState(null);

  const [checkbox0, setCheckbox0] = useState(null);

  let cargarDatosMensaje = (e) => {
    setTextMensage(e.target.value);
    setCheckbox0(0);
  };

  let cargarDatosPhoto = (e) => {
    prePhoto(e);

    setFile(e.target.files[0]);
  };

  let onSutmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("message", textMensage);
    data.append("file", file);    
    data.append("cero", checkbox0);
    data.append('idColaborador', cred.carnet)    

    let pathImagen = {};
    pathImagen.data = "";
    if (file) {
      pathImagen = await loadImagenChange(data);
    }

    btnEnviar(data);

    await GetFetchNotificacion.setNotificacion(
      textMensage,
      pathImagen.data,
      "Alumnos",
      cred.nombre,
      cred.token,
      '',
      cred.carnet
    );

    noti(textMensage, "Alumnos", cred.carnet);
  };

  // let notificacionAviso = (notificacion, usuarios_destino) => {
  //   socket.emit("aviso_notificacion", notificacion, usuarios_destino, cred.carnet);
  // };

  const btnEnviar = async (data) => {
    if (textMensage) {
      let message = textMensage;
      // console.log(message);
      let result = await GetFetchPush.sendMessageAll(data);
      if (+result.success === 1) {
        document.getElementById("texttareaMessage").value = "";
        document.getElementById(
          "pushAlert"
        ).innerHTML = `<div class="alert alert-warning alert-dismissible fade show" role="alert">
                <strong>Notificación enviado con exíto</strong> <br></br>
                ${message}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>`;
      }
      console.log(result.success);
    }
  };

  let loadImagenChange = async (dataFile) => {
    if (dataFile) {
      return await GetFetchPush.sendPhotoAll(dataFile);
    }
  };

  let prePhoto = (e) => {
    let imgDiv = document.getElementById("loadImagen"); //Elemento donde se carga la img vista previa
    let TmpPath = URL.createObjectURL(e.target.files[0]);
    imgDiv.innerHTML = `<img src="${TmpPath}" style='width: 45%' />`;
  };

  useEffect(() => {
    loadMenu();
  }, []);
  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={datos.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={datos.carnet}
            nombre={datos.nombre}
            perfil={datos.perfil}
            carrera={datos.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-2">Notificación general</h2>
        <p className="text-muted mb-3">
          Mensaje para todas las carreras de pregrado.
        </p>
        <span className="esen-chip esen-chip--info mb-4">
          <i className="fa fa-bullhorn mr-1" aria-hidden="true"></i> Todos los alumnos
        </span>

        <div className="card mt-3">
          <div className="card-body">
            <form id="formUP" onSubmit={onSutmit}>
              <div className="form-group">
                <label htmlFor="texttareaMessage">
                  Mensaje de la notificación
                </label>
                <textarea
                  className="textTareaPush"
                  style={{ height: "228px" }}
                  id="texttareaMessage"
                  name="message"
                  rows="8"
                  onChange={cargarDatosMensaje}
                ></textarea>
              </div>
              <div className="form-group">
                <label htmlFor="fileIMGE">Imagen para la notificación (opcional)</label>
                <input
                  type="file"
                  name="photo"
                  id="fileIMGE"
                  className="form-control-file"
                  onChange={cargarDatosPhoto}
                />
                <div id="loadImagen" className="mt-2"></div>
              </div>
              <div className="form-group mb-0">
                <button type="submit" className="btn btn-primary">
                  <i className="fa fa-paper-plane mr-2" aria-hidden="true"></i>
                  Enviar notificación
                </button>
              </div>
            </form>
          </div>
        </div>

        <div id="pushAlert" className="mt-3"></div>

        <Link to="/alertmenu" className="btn btn-outline-primary mt-3">
          <i className="fa fa-reply mr-2" aria-hidden="true"></i> Menú de alertas
        </Link>
      </div>
    </div>
  );
};

export default Push;
